import * as yup from 'yup'

export default (t) => yup.object().shape({
  title: yup
    .string()
    .trim()
    .required(t('task.errors.task_title_required'))
    .max(100, t('task.errors.task_title_max_length', { max: 100 }))
})
